/* global document */

export default function touchEnabled() {
  if (typeof document === 'undefined') return false;
  return 'ontouchstart' in document.documentElement;
}
